import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../../AccountForm.meta';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { OwnerTypeDTO } from '../../../../../../../api/useAccountsQuery';
import { Card } from '../../../../../../../../../CommonComponents/OPL/Card/Card';

export const TotalSummary = () => {
  const formBag = useFormContext<FormFields>();
  const { watch } = formBag;

  const ownerModel = watch('bankAccount.OwnerModel');

  const totalPercentage =
    ownerModel
      .filter(owner => owner.Name && owner.Percentage)
      .reduce((acc, owner) => +(owner.Percentage || 0) + acc, 0) || 0;

  return (
    <>
      <Box px="8" display="flex" justifyContent="end" css="gap: 16px">
        <Text fontSize="body" fontWeight={600}>
          Total Ownership:
        </Text>
        <Text
          fontSize="body"
          fontWeight={600}
          color={totalPercentage === 100 ? 'success.500' : 'neutral.600'}
        >
          {totalPercentage}%
        </Text>
      </Box>

      <Card p="8">
        <Text fontSize="body" fontWeight={600}>
          Ownership Summary:
        </Text>

        {ownerModel
          .filter(b => b.Name && b.Percentage)
          .map(({ Name, OwnerType, Percentage }) => (
            <Box key={Name} display="flex" justifyContent="space-between" alignItems="center">
              <Text fontSize="body">
                {Name} ({OwnerTypeDTO[OwnerType]})
              </Text>
              <Text fontSize="body">{Percentage}%</Text>
            </Box>
          ))}
      </Card>
    </>
  );
};
